import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7906cc67"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center","margin-top":"12px","font-size":"18px","color":"#666"} }, "微信扫码前往", -1))
const _hoisted_3 = { class: "mobile-mall" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "移动商城", -1))

import { MobileOutlined } from '@ant-design/icons-vue';
import { ref } from 'vue';
import { queryCodeImg } from './services';


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileMall',
  props: {
  visible: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props



const codeImg = ref('');

const getCodeImg = async () => {
  const res = await queryCodeImg();
  codeImg.value = res;
};

getCodeImg();

return (_ctx: any,_cache: any) => {
  const _component_a_popover = _resolveComponent("a-popover")!

  return (__props.visible)
    ? (_openBlock(), _createBlock(_component_a_popover, {
        key: 0,
        "overlay-inner-style": { padding: 0 }
      }, {
        content: _withCtx(() => [
          _createElementVNode("img", { src: codeImg.value }, null, 8, _hoisted_1),
          _hoisted_2
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(MobileOutlined)),
            _hoisted_4
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})